import { InputText } from 'primereact/inputtext';

interface EditTextModel {
  title?: string;
  onChange: (text: string) => void;
  height?: string;
  value?: string;
  icon?: any;
  maxLength?: number;
  disabled?: boolean;
  width?: string;
  onBlur?: (value: string) => any;
}
export const EditText: React.FC<EditTextModel> = ({
  onChange,
  title,
  height,
  value,
  icon,
  maxLength,
  disabled = false,
  width,
  onBlur,
}) => {
  return (
    <div
      style={{
        flex: '1', // Flex-grow, flex-shrink, and base size of 250px
        minWidth: '250px', // Ensure a minimum width of 250px
        marginBottom: '16px', // Optional bottom margin for row spacing
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <label style={{ fontSize: '14px', color: '#4b5563' }}>{title}</label>
      <div
        style={{
          position: 'relative',
          display: 'inline-block',
          width: '100%',
          marginTop: '4px',
        }}
      >
        <InputText
          style={{
            height: height ?? '36px',
            width: width ?? '100%',
            paddingRight: icon ? '36px' : '', // Space for the icon
          }}
          autoComplete="off"
          disabled={disabled}
          maxLength={maxLength}
          onBlur={() => {
            onBlur && onBlur(value);
          }}
          id="username"
          aria-describedby="username-help"
          onChange={(e) => onChange(e.target.value)}
          {...(value !== undefined && { value })}
        />
        {/*{icon && (
          <img
            src={icon}
            className="pi pi-user"
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#6c757d',
              backgroundColor: 'white', // Optional: matches input background
              borderRadius: '50%',
              padding: '4px',
              pointerEvents: 'none', // Avoid blocking input field
            }}
          />
        )}*/}

        {icon && typeof icon === 'string' ? (
          <img
            src={icon}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'white',
              borderRadius: '50%',
              padding: '4px',
              pointerEvents: 'none',
              width: '16px',
              height: '16px',
            }}
          />
        ) : (
          <span
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#6c757d',
              backgroundColor: 'white',
              borderRadius: '50%',
              /*padding: '4px',*/
              pointerEvents: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </span>
        )}
      </div>
    </div>
  );
};
